document.addEventListener("DOMContentLoaded", (_event) => {
  const pages = document.getElementsByClassName('service-times')
  if (pages.length == 0) return

  const currentClearButtons = () => {
    return document.querySelectorAll("[data-clear-input=true]");
  }

  // 初めのクリアボタンの表示制御
  const hideFirstClearButton = (clearButtons) => {
    if (clearButtons.length === 1) {
      clearButtons[0].classList.add("hide");
    }
  };

  // クリアボタンのenable/disabled制御
  const enableClearButtons = () => {
    for (const clearButton of currentClearButtons()) {
      clearButton.classList.remove("disabled");
    }
  }
  const disableClearButtons = () => {
    for (const clearButton of currentClearButtons()) {
      clearButton.classList.add("disabled");
    }
  }

  // 期間指定inputの削除
  const removeServiceTimeForm = (event) => {
    event.preventDefault();

    const target = event.target;
    const removeForm = target.closest("[data-service-time-form]");

    // 設定済みの入力を削除する場合はdestroyをセットしてinputを隠す
    if (removeForm.dataset.serviceTimeForm === "persisted") {
      const hiddenDestroyInput = removeForm.querySelector("input[type=hidden][disabled]");
      hiddenDestroyInput.disabled = false;
      target.closest("[data-clear-input]").dataset.clearInput = false;
      removeForm.classList.add("hide");
    } else {
      removeForm.remove();
    }

    hideFirstClearButton(document.querySelectorAll("[data-clear-input=true]"))
  };

  // 初期表示時のクリアボタンへのイベントリスナー追加
  const clearInputButtons = currentClearButtons();
  for(const clearInputButton of clearInputButtons) {
    clearInputButton.addEventListener('click', removeServiceTimeForm);
  }
  hideFirstClearButton(clearInputButtons)

  const getDatetimeInputs = () => document.getElementsByClassName('datetime')
  const getDestroyFlags = () => document.querySelectorAll('input[name*="[_destroy]"]')

  const serviceTimeMessageInput = document.getElementById('service-time-message-input')
  const addServiceTime = document.getElementById('add-service-time')
  const enableServiceTimes = () => {
    addServiceTime.classList.remove("disabled");
    enableClearButtons();
    for(const element of getDestroyFlags()) {
      element.disabled = true
    }
    for(const element of getDatetimeInputs()) {
      element.disabled = false
    }
    serviceTimeMessageInput.disabled = true
  }

  const enableServiceTimeMessage = () => {
    addServiceTime.classList.add("disabled");
    disableClearButtons();
    for(const element of getDestroyFlags()) {
      element.disabled = false
    }
    for(const element of getDatetimeInputs()) {
      element.disabled = true
    }
    serviceTimeMessageInput.disabled = false
  }

  const unsetForm = () => {
    addServiceTime.classList.add("disabled");
    disableClearButtons();
    for(const element of getDestroyFlags()) {
      element.disabled = false
    }
    for(const element of getDatetimeInputs()) {
      element.disabled = true
    }
    serviceTimeMessageInput.disabled = true
  }

  const checkedRadio = document.querySelector('.hidden-radio:checked')
  if (checkedRadio.id == "service-time") {
    enableServiceTimes()
  } else if (checkedRadio.id == "service-time-message") {
    enableServiceTimeMessage()
  } else {
    unsetForm()
  }

  const clonedBase = document.querySelector('.service-time-form')
  const formContainer = clonedBase.parentElement
  addServiceTime.addEventListener('click', (event) => {
    event.preventDefault()
    const newServiceTimeForm = clonedBase.cloneNode(true)
    const inputs = newServiceTimeForm.querySelectorAll('input')
    const idField = newServiceTimeForm.querySelector('input[name*="[id]"]')
    idField.value = null

    for(const element of newServiceTimeForm.getElementsByClassName('with-error')) {
      const input = element.querySelector('.datetime')

      newServiceTimeForm.replaceChild(input, element)
    }

    const order = formContainer.childElementCount
    for(const element of inputs) {
      const name = element.name
      const newName = name.replace(/\[(\d+)\]/, () => `[${order}]`)

      element.name = newName
    }
    for(const element of newServiceTimeForm.getElementsByClassName('datetime')) {
      element.value = ''
    }

    formContainer.appendChild(newServiceTimeForm)

    // 新たなクリアボタンにイベントリスナー追加し、初めのクリアボタンのhideを解除
    const newClearInputButton = newServiceTimeForm.querySelector("[data-clear-input=true]");
    newClearInputButton.addEventListener('click', removeServiceTimeForm);
    newClearInputButton.classList.remove("hide");
    clearInputButtons[0].classList.remove("hide");
  })

  const serviceTimeButton = document.getElementById('service-time')
  const serviceTimeMessageButton = document.getElementById('service-time-message')
  const noSettingButton = document.getElementById('no-setting')
  serviceTimeButton.addEventListener('change', () => {
    enableServiceTimes()
  })
  serviceTimeMessageButton.addEventListener('change', () => {
    enableServiceTimeMessage()
  })
  noSettingButton.addEventListener('change', () => {
    unsetForm()
  })
})
